export default __webpack_public_path__ + "static/media/CNo.49-3.a351688c.jpg";